import React, { useState } from "react";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
// import Pager from "../../Components/Global/Pager";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import MostCommentsSleevesContainer from "~/Components/Containers/MostCommentsSleevesContainer";
import SleeveMini from "~/Components/SleeveMini";

const PopularCommentsPage = ({ location }) => {
  let history = useHistory();
  const queryStringParams = queryString.parse(location.search);
  const { page: startPage = 1, find: searchTerm } = queryStringParams;
  const [page, setPage] = useState(parseInt(startPage, 10));

  const updatePageCallBack = (toPage) => {
    history.push(`?find=${searchTerm}&page=${toPage}`);
    setPage(toPage);
  };

  return (
    <div className="page-home">
      <Helmet>
        <title>Sleevery | Search | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <h1 className="page-header">
            <i className="fas fa-trophy"></i> Most Comments
          </h1>
        </Col>
        <Col xs={12}>
          <MostCommentsSleevesContainer
            // page={page}
            render={({ sleeves }) => {
              // const pages = Math.ceil(total / perPage);

              return (
                <Row>
                  <Col xs={12}>
                    <ul className="results cover-wall">
                      {sleeves.map((sleeve) => (
                        <li key={sleeve.id}>
                          <SleeveMini key={`search-${page}-${searchTerm}`} sleeve={sleeve} />
                        </li>
                      ))}
                    </ul>
                  </Col>

                  <Col xs={12}>
                    <div style={{ padding: "20px 0" }}>
                      {/* <Pager  className="pagination-footer" page={page} pages={pages} updatePage={updatePageCallBack} /> */}
                    </div>
                  </Col>
                </Row>
              );
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PopularCommentsPage;
